import { ApiService } from '../parents/api.service';
import { HttpApiClient } from '../api/http-api-client';
import { StockModel } from '../models/stock.model';

export class StocksApiService extends ApiService {
  static endpoint = 'stocks';

  /**
   * @param {Number|null} stockId
   * @return {String}
   * @protected
   */
  static buildStockUrl(stockId = null) {
    return this.buildUrl(stockId);
  }

  /**
   * @param {String|Number} stockId
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<StockModel>>}
   * @public
   */
  static async get(stockId, builderCallback = null, config = {}) {
    return HttpApiClient.get(this.buildStockUrl(stockId), {
      ...config,
      dataModel: StockModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {builderCallback|null} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<StockModel>>}
   * @public
   */
  static getAll(builderCallback = null, config = {}) {
    return HttpApiClient.get(this.buildStockUrl(), {
      ...config,
      dataModel: StockModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }
}
